module.exports = __webpack_public_path__ + "media/point.fd0620e8.mp3";